export const GTM_ID = 'GTM-NW2WR68X';

export type AuthMethod = 'password' | 'nonce' | 'linkedin' | 'google' | 'exhibition';

export type SignUpMethod = 'password' | 'linkedin' | 'google' | 'exhibition';

export type AnalyticsEvent =
  | 'login'
  | 'login_failed'
  | 'sign_up';

type AnalyticsPayload = Record<string, string | number | boolean | undefined>;

let gtmInitialized = false;

export function initGtm(): void {
  if (gtmInitialized || typeof window === 'undefined') {
    return;
  }

  gtmInitialized = true;
  window.dataLayer = window.dataLayer ?? [];

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });
}

export function trackEvent(event: AnalyticsEvent, payload?: AnalyticsPayload): void {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event,
    ...payload,
  });
}
